
export { xss } from "/home/runner/work/apollo/apollo/packages/core/utils/format/src/xss/xss.ts"